import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=676af7c0&scoped=true&"
import script from "./SidebarNav.vue?vue&type=script&lang=js&"
export * from "./SidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=676af7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_bd47uzbtgolpottv4tyra2y574/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676af7c0",
  null
  
)

export default component.exports